import React from 'react'
import styled from 'styled-components'
import { Box, Typography } from '@mui/material'
import DownloadAddStoreButton from './DownloadAddStoreButton'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import theme, { SERIF_FONT, MONO_FONT } from '../../../../theme'

const Section = styled(Box)`
  background: linear-gradient(
    180deg,
    ${theme.palette.background.paper} 0%,
    ${theme.palette.background.default} 100%
  );
  padding: 80px 24px;
  text-align: center;
`

const Inner = styled(Box)`
  max-width: 560px;
  margin: 0 auto;
`

const Eyebrow = styled(Typography)`
  && {
    font-family: ${MONO_FONT};
    font-size: 0.72rem;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: ${theme.palette.text.secondary};
    margin-bottom: 16px;
  }
`

const Headline = styled(Typography)`
  && {
    font-family: ${SERIF_FONT};
    font-size: clamp(28px, 4vw, 40px);
    font-weight: 500;
    line-height: 1.15;
    letter-spacing: -0.015em;
    color: ${theme.palette.text.primary};
    margin-bottom: 14px;
  }
`

const Subtext = styled(Typography)`
  && {
    font-size: 16px;
    line-height: 1.65;
    color: ${theme.palette.text.secondary};
    margin-bottom: 36px;
  }
`

const DownloadApp: React.FC = () => {
  const { isSmallScreen } = useAppUtilities()

  return (
    <Section>
      <Inner>
        <Eyebrow>Available on iOS &amp; Android</Eyebrow>
        <Headline variant="h2">
          Scan the menu.
          <br />
          Know what to order.
        </Headline>
        <Subtext variant="body1">
          Picks built from what you actually order — so every meal is the right
          one.
        </Subtext>
        <DownloadAddStoreButton
          height={isSmallScreen ? '36px' : '44px'}
          width={isSmallScreen ? '118px' : '148px'}
          buttonAlign="center"
        />
      </Inner>
    </Section>
  )
}

export default DownloadApp
